'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const RequisitionIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="RequisitionIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_48_8609)">
          <path
            d="M6.5 6.5V1.5C6.5 1.23478 6.60536 0.98043 6.79289 0.792893C6.98043 0.605357 7.23478 0.5 7.5 0.5H17.5L23.5 6.5V22.5C23.5 22.7652 23.3946 23.0196 23.2071 23.2071C23.0196 23.3946 22.7652 23.5 22.5 23.5H15.5"
            stroke="#3D517B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 0.5V5.5C17.5 5.76522 17.6054 6.01957 17.7929 6.20711C17.9804 6.39464 18.2348 6.5 18.5 6.5H23.5"
            stroke="#3D517B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.5 20.5H13.5V22.5C13.5 22.7652 13.3946 23.0196 13.2071 23.2071C13.0196 23.3946 12.7652 23.5 12.5 23.5H2.5C2.23478 23.5 1.98043 23.3946 1.79289 23.2071C1.60536 23.0196 1.5 22.7652 1.5 22.5V20.5Z"
            stroke="#3D517B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 17.5C9.9793 17.5002 9.47904 17.2973 9.10556 16.9345C8.73209 16.5717 8.51484 16.0775 8.5 15.557C8.49097 15.2369 8.55892 14.9194 8.69813 14.631C8.83734 14.3427 9.04375 14.092 9.3 13.9C9.80372 13.5222 10.1758 12.9955 10.3635 12.3945C10.5513 11.7935 10.5452 11.1487 10.3461 10.5513C10.1469 9.95398 9.76493 9.43444 9.25413 9.06627C8.74333 8.69811 8.12965 8.5 7.5 8.5C6.87035 8.5 6.25667 8.69811 5.74587 9.06627C5.23507 9.43444 4.85306 9.95398 4.65395 10.5513C4.45484 11.1487 4.44872 11.7935 4.63646 12.3945C4.8242 12.9955 5.19628 13.5222 5.7 13.9C5.95543 14.0925 6.16126 14.3432 6.3004 14.6312C6.43953 14.9192 6.50796 15.2362 6.5 15.556C6.48542 16.0767 6.26828 16.5711 5.89478 16.9341C5.52127 17.2972 5.02087 17.5002 4.5 17.5H2.5C1.96957 17.5 1.46086 17.7107 1.08579 18.0858C0.710714 18.4609 0.5 18.9696 0.5 19.5C0.5 19.7652 0.605357 20.0196 0.792893 20.2071C0.98043 20.3946 1.23478 20.5 1.5 20.5H13.5C13.7652 20.5 14.0196 20.3946 14.2071 20.2071C14.3946 20.0196 14.5 19.7652 14.5 19.5C14.5 18.9696 14.2893 18.4609 13.9142 18.0858C13.5391 17.7107 13.0304 17.5 12.5 17.5H10.5Z"
            stroke="#3D517B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M21 10.499H13" stroke="#3D517B" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M21 18.499H17" stroke="#3D517B" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M21 14.499H14.5" stroke="#3D517B" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </SvgIcon>
  )
}

RequisitionIcon.propTypes = {
  sx: PropTypes.object
}
